import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/solid/document-fill.svg'


const _hoisted_1 = { class: "link" }
const _hoisted_2 = { class: "truncate inline-block space-x-1 text-sm w-full" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "flex bg-gray-100 border-2 border-gray-200 w-54 h-48 text-brand-500 rounded-md" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "linked-icon w-16 m-auto",
    src: _imports_0,
    alt: "document icon"
  })
], -1)
const _hoisted_12 = { class: "text-gray-900 w-54 truncate font-medium mt-2" }

import { // languages
		useI18n
	} from 'vue-i18n'
	
	import { // store
		localesStore
	} from '@/store/locales'

	import { 
		store as _userStore
	} from '@/store/user'

	import { // types
		S3Json
	} from '@/types'

	import { // vue
		inject,
		onMounted,
		ref
	} from 'vue'

	
	const __default__ = { name: 'SceneSoundSongScoresFiles' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		files: {
			type: Object,
			default: () => {return {}}
		},
		showDetails: {
			type: Function, 
			default: () => {return}
		},
		previous: {
			type: Object, 
			default: () => {return {}}
		},
		parent: {
			type: Object, 
			default: () => {return {}}
		}
	},
  setup(__props) {

	const props = __props
	
	const _localesStore = localesStore()
	const userStore = _userStore()

	const {t} = useI18n()
	
	const loading = ref(true)
	const fetchS3File: any = inject('fetchS3File')
	const signedUrlSong = ref('')
	const signedUrlPdf = ref('')
	const signedUrlKaraoke = ref('')
	const pdf = ref<S3Json>({} as S3Json)
	const isStaff = ref(userStore.getContactType === 'Staff')
	onMounted(async () => {
		try { // fetching score files from s3
			loading.value = true
			signedUrlSong.value = await fetchS3File(props.files?.['jobs_songs__jobs_songs_scores__SCORES__scoreID::s3JSONscoreSONG'])
			signedUrlPdf.value = await fetchS3File(props.files?.['jobs_songs__jobs_songs_scores__SCORES__scoreID::s3JSONscorePDF'])
			signedUrlKaraoke.value = await fetchS3File(props.files?.['jobs_songs__jobs_songs_scores__SCORES__scoreID::s3JSONkaraokeM4A'])
		}
		catch(e) {
			console.error(e)
		}
		finally {
			loading.value = false
		}
	})


return (_ctx: any,_cache: any) => {
  const _component_ArrowLeftIcon = _resolveComponent("ArrowLeftIcon")!
  const _component_data_display = _resolveComponent("data-display")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.showDetails(__props.previous, 'songScore', null, null))),
        class: "flex justify-start items-center cursor-pointer"
      }, [
        _createVNode(_component_ArrowLeftIcon, { class: "w-5 h-5" }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)("nav.returnToScores")), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createVNode(_component_data_display, {
          loading: loading.value,
          label: _unref(_localesStore).getLabel('183')
        }, {
          custom: _withCtx(() => [
            _createElementVNode("audio", {
              controls: "",
              src: signedUrlSong.value
            }, [
              _createElementVNode("source", {
                src: signedUrlSong.value,
                type: "audio/mpeg"
              }, null, 8, _hoisted_5),
              _createTextVNode(" " + _toDisplayString(_unref(t)("placeholders.audioNotSupported")), 1)
            ], 8, _hoisted_4)
          ]),
          _: 1
        }, 8, ["loading", "label"])
      ]),
      (isStaff.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_data_display, {
              loading: loading.value,
              label: _unref(_localesStore).getLabel('446')
            }, {
              custom: _withCtx(() => [
                _createElementVNode("audio", {
                  controls: "",
                  src: signedUrlKaraoke.value
                }, [
                  _createElementVNode("source", {
                    src: signedUrlKaraoke.value,
                    type: "audio/mpeg"
                  }, null, 8, _hoisted_8),
                  _createTextVNode(" " + _toDisplayString(_unref(t)("placeholders.audioNotSupported")), 1)
                ], 8, _hoisted_7)
              ]),
              _: 1
            }, 8, ["loading", "label"])
          ]))
        : _createCommentVNode("", true),
      (isStaff.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_data_display, {
              loading: loading.value,
              label: _unref(_localesStore).getLabel('286')
            }, {
              custom: _withCtx(() => [
                _createElementVNode("a", {
                  target: "_blank",
                  class: "w-full truncate hover:opacity-70",
                  href: signedUrlPdf.value,
                  download: ""
                }, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, _toDisplayString(pdf.value?.s3FilePathShortRaw?.split('/')[3]), 1)
                ], 8, _hoisted_10)
              ]),
              _: 1
            }, 8, ["loading", "label"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})